import type { FaireProductEntity } from "../../entity_types/product";

export const p_tferhq96xn: FaireProductEntity = {
  token: "p_tferhq96xn",
  type: "product",
  name: "Cozy Cropped Tank Top 2pcs Jogger Pants Set | S-XL",
  brandToken: "b_m95natja9m",
  brandName: "Aapparella",
  imageUrl:
    "https://cdn.faire.com/fastly/0191080468309b39da5d1ba039ae7503d02e9364fc2e47238b8a10d2948becbd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e56af84572e506f858d2242efaa735b97b9a197968274afe43ad6f4c515bfa34.jpeg",
    "https://cdn.faire.com/fastly/929367e60bbb786b87b2f0bffb61d5662df872b4ab0cf5c8cfbd610a72b61e49.jpeg",
    "https://cdn.faire.com/fastly/3ef5796add5655da8fdbaa0d668035f48497525b0a51821ebded696f880b62ba.jpeg",
    "https://cdn.faire.com/fastly/186b895bf5eb27ce5fe676159608157af852be7851caaafcb30078ed250178f4.jpeg",
    "https://cdn.faire.com/fastly/82cf227cae17f41f94a240cebe8310bcdb2dedf4d0d9e4571738043bf9111dba.jpeg",
    "https://cdn.faire.com/fastly/9595487975d8900c4c906499fd66ac9554e1a6da7420baefc2e324c1c18e18fe.jpeg",
    "https://cdn.faire.com/fastly/43b85d9345cb1de5a3fd3e23e1be40acbed85734a38c054dee69c5a70df56321.png",
  ],
  priceDollars: 27.5,
  description:
    "🔹 Fabric | 95%Cotton+5%Elastane\n🔹 Pattern | Solid\n🔹 Style | Casual\n🔹 Season | Spring  & Summer 2026\n\n📋 Tag |  Care Label per piece, pls read the size on the care label! We also offer brand tag customization service, any request pls let us know to assist you!!\n\nTo make you happy and easy shopping, we will do our absolute best to help you, any question about styles/orders, pls contact us freely!💗",
  tags: [],
  msrpDollars: 55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:09.470Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
